import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { Text } from '@qonsoll/react-design'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const NewspaperStatusFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslations()

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'isBlocked',
    operand: '==',
    type: 'newspaperStatus'
  })

  const newspaperStatus = [
    { value: true, name: 'Blocked' },
    { value: false, name: 'Active' }
  ]

  return (
    <details
      open={
        localStorage.getItem(`newspaperStatus-details-visibility`) === 'opened'
      }>
      <summary onClick={onToggleDetails}>{t('Newspaper status')}</summary>
      {newspaperStatus?.map((value, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(value)}
          onChange={() => onChange(value)}>
          <Text wordBreak="break-all">
            {t(value?.name) || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

NewspaperStatusFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default NewspaperStatusFilter
